import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, propTypes } from 'redux-form';
import { Button } from 'components/UI';
import { searchSvg as SearchSvg } from 'theme/icon';
import { connect } from 'react-redux';
import { Input } from 'antd';
import selector from 'redux_store/selectors/tenderCard/attributes';
import { saveAttributes, saveAttribute } from 'redux_store/modules/tenderCard';
import { VelocityTransitionGroup } from 'velocity-react';
import _ from 'lodash';
import AttributeComponent from './components';
import DetailsComponent from './details';
import styles from './styles.scss';
import validate from './control/validate';

const TenderAttributes = props => {
  const [items, setItems] = useState(props.initialValues.attributes);
  const [detailsOpenIndex, _setDetailsOpenIndex] = useState(null);
  const [position, setPosition] = useState({});
  const [detailsPosition, setDetailsPosition] = useState(null);
  const [filtredItems, setFiltredItems] = useState(props.initialValues.attributes);
  const [search, setSearch] = useState('');
  const { handleSubmit, reset } = props;
  const list = useRef(null);
  const prevIndex = useRef(null);
  const details = useRef(null);
  const myStateRef = React.useRef(detailsOpenIndex);
  const setDetailsOpenIndex = data => {
    myStateRef.current = data;
    _setDetailsOpenIndex(data);
  };

  const getDetailsPosition = index => {
    if (list.current && list.current.clientWidth) {
      const countInLine = Math.floor((list.current.clientWidth + 28) / 363);
      const line = Math.ceil((index + 1) / countInLine) + 2;
      return `${line} / 1 / ${line} / ${countInLine + 1}`;
    }
  };
  const getPosition = index => {
    if (list.current && list.current.clientWidth) {
      const countInLine = Math.floor((list.current.clientWidth + 28) / 363);
      let line = Math.floor(index / countInLine) + 1;
      const detailsLine =
        myStateRef.current || myStateRef.current === 0 ? Math.floor(myStateRef.current / countInLine) + 2 : 10000;
      line += (myStateRef.current || myStateRef.current === 0) && line > detailsLine ? 1 : 0;
      const column = (index + 1) % countInLine ? (index + 1) % countInLine : countInLine;
      return `${line} / ${column} / ${line} / ${column}`;
    }
    return 'unset';
  };
  const reloadPosition = (values = filtredItems) => {
    const newPosition = {};
    let i = 0;
    values.forEach((item, index) => {
      newPosition[index] = getPosition(i);
      i += 1;
    });
    setPosition(newPosition);
  };
  const onResize = useRef(
    _.debounce(() => {
      setDetailsPosition(getDetailsPosition(myStateRef.current));
      reloadPosition();
    }, 300),
  ).current;
  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    setItems(props.initialValues.attributes);
  }, [props.initialValues.attributes]);
  const onSearchChange = useRef(
    _.debounce(val => {
      let newItems = [];
      if (val && val.length > 0) {
        items.forEach((el, index) => {
          if (el.name.toLowerCase().match(val.toLowerCase())) {
            newItems[index] = el;
          }
        });
      } else {
        newItems = items;
      }
      setFiltredItems(newItems);
      reloadPosition(newItems);
    }, 300),
  ).current;

  useEffect(() => {
    if (prevIndex.current !== detailsOpenIndex) {
      prevIndex.current = detailsOpenIndex;
    }
  }, [detailsOpenIndex]);

  const delay = prevIndex.current || prevIndex.current === 0 ? 90 : 0;
  return (
    <div className={styles.attributesWrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>Параметры тендера</h2>
        <div className={styles.search}>
          <Input
            value={search}
            className={styles.search}
            placeholder="Найти параметры тендера"
            suffix={<SearchSvg alt="" />}
            onChange={e => {
              setSearch(e.target.value);
              onSearchChange(e.target.value);
            }}
          />
        </div>
        <div className={styles.buttons}>
          <Button
            color="blue"
            disabled={!props.dirty || props.submitting || !props.valid || props.submitSucceeded}
            onClick={() => {
              if (props.valid) {
                handleSubmit();
                setDetailsOpenIndex(null);
              }
            }}
          >
            Сохранить все
          </Button>
          <Button
            disabled={!props.dirty || props.submitting || !props.valid || props.submitSucceeded}
            onClick={() => {
              reset();
              setDetailsOpenIndex(null);
            }}
          >
            Отменить все
          </Button>
        </div>
      </div>
      <div className={styles.attributesList}>
        <form onSubmit={handleSubmit}>
          <div className={styles.list} ref={list}>
            {filtredItems.length > 0 ? (
              filtredItems.map((item, index) => {
                const isDetailsOpen = myStateRef.current === index;
                return (
                  <React.Fragment>
                    <div
                      key={`${item.id}_attribute`}
                      style={{
                        gridArea: position[index],
                        position: 'relative',
                      }}
                    >
                      <Field
                        index={index}
                        name={`attributes[${index}]`}
                        component={AttributeComponent}
                        validate={validate[item.typeId]}
                        onEdit={() => {
                          if (item.typeId === 3 || item.typeId === 9) {
                            setDetailsPosition(getDetailsPosition(index));
                            setDetailsOpenIndex(index);
                          }
                        }}
                        onClose={() => setDetailsOpenIndex(null)}
                        isDetailsOpen={isDetailsOpen}
                        isDelay={delay && prevIndex.current !== index}
                        isShowArrow={item.typeId === 3 || item.typeId === 9}
                        default={{
                          touch: props.touch,
                          untouch: props.untouch,
                          change: props.change,
                          isEditAccess: props.isEditAccess,
                          anyTouched: props.anyTouched,
                        }}
                      />
                    </div>
                  </React.Fragment>
                );
              })
            ) : (
              <React.Fragment>Не найдено ни одного параметра тендера</React.Fragment>
            )}
            <VelocityTransitionGroup
              enter={{
                animation: 'fadeIn',
                duration: 100,
                stagger: delay,
                style: {
                  gridArea: detailsPosition,
                  display: 'block',
                },
                begin: e => {
                  reloadPosition();
                  e[0].parentNode.style.setProperty('grid-area', detailsPosition);
                  details.current = e[0].parentNode;
                },
                delay,
              }}
              leave={{
                animation: 'fadeOut',
                style: {
                  display: 'none',
                },
                duration: 100,
                stagger: delay,
                complete: () => {
                  reloadPosition();
                  if (!myStateRef.current && myStateRef.current !== 0 && details.current) {
                    details.current.style.setProperty('grid-area', 'unset');
                  }
                },
              }}
            >
              {myStateRef.current || myStateRef.current === 0 ? (
                <Field
                  index={myStateRef.current}
                  key={`details_${myStateRef.current}`}
                  name={`attributes[${myStateRef.current}]`}
                  component={DetailsComponent}
                  default={{
                    touch: props.touch,
                    untouch: props.untouch,
                    change: props.change,
                    isEditAccess: props.isEditAccess,
                    anyTouched: props.anyTouched,
                  }}
                  anyTouched={props.anyTouched}
                  delay={delay}
                  onCancel={() => setDetailsOpenIndex(null)}
                  onSave={() => setDetailsOpenIndex(null)}
                  onDetailsClose={() => setDetailsOpenIndex(null)}
                />
              ) : null}
            </VelocityTransitionGroup>
          </div>
        </form>
      </div>
    </div>
  );
};
TenderAttributes.propTypes = {
  ...propTypes,
  isEditAccess: PropTypes.bool.isRequired,
};

const TenderAttributesForm = reduxForm({
  form: 'cardAttribute',
  destroyOnUnmount: false,
  // Не убирать следующие 4 опции
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
  onSubmit: saveAttributes,
  onChange: (values, dispatch, props) => {
    if (props.dirty && values.field) {
      const attributes = props.initialValues.attributes.map(defaultEl => {
        if (defaultEl.id === values.field) {
          return values.attributes.find(val => val.id === values.field);
        }

        return defaultEl;
      });

      dispatch(saveAttribute(props.tenderId, { id: values.field, attributes }));
    }
  },
})(TenderAttributes);

export default connect(selector)(TenderAttributesForm);
